export const LIFE_MILESTONE_2_CONSTANTS = {
  LIFE_MILESTONE_2_FIELDS_CONFIG: [
    {
      fieldName: "block_main_title",
      label: "Main title (52px)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "On-Campus Graduation Ceremony",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "block_subtitle",
      label: "Second title (32px)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "at IIT Kharagpur",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "block_body",
      label: "Body (18px)",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Supporting copy",
      required: false,
      defaultValue: "",
      rows: 4,
    },
    {
      fieldName: "block_cta_label",
      label: "Button label (16px)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Start Learning Now",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "block_cta_url",
      label: "Button URL",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://… — used when Is CTA is off",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "is_cta",
      label: "Is CTA",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder:
        "On = open lead capture popup instead of button URL",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "block_feature_label",
      label: "Feature line with check icon (18px)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Faculty Interaction",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_color",
      label: "Section background",
      value: "#291973",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#291973",
      required: false,
      defaultValue: "#291973",
    },
    {
      fieldName: "hero_image",
      label: "Hero image (668.4 × 602)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload hero image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "hero_image_alt",
      label: "Hero image alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: true,
    },
  ],
};
